import { FlightTicketVerification } from '@/api/MyBooking/myBooking.interfaces';
import { useNowUTC } from '@/helpers/useNow';

export function isLoading(verification?: FlightTicketVerification | null) {
    if (!verification) {
        return false;
    }

    if (isExpired(verification)) {
        return false;
    }

    return !verification.confirmed && !verification.url;
}

export function isConfirmed(verification?: FlightTicketVerification | null) {
    if (!verification) {
        return false;
    }

    return verification.confirmed;
}

export function isExpired(verification: FlightTicketVerification | null | undefined) {
    const { now } = useNowUTC();

    if (!verification) {
        return false;
    }

    if (verification.url && !verification.validUntil) {
        return true;
    }

    return verification.validUntil
        ? new Date(verification.validUntil).getTime() <= now.value
        : false;
}
